import SigliveServiceV3 from 'Service/sigliveServiceV3';

const getExportReportBrand = async (queries) => {
  const { data } = await SigliveServiceV3({
    method: 'GET',
    url: `/reporting/summary-brand/export?${queries}`,
    responseType: 'blob',
  });

  return data;
};

export default getExportReportBrand;
